import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Catalogue from './pages/Catalogue';
import Search from './pages/Search';
import PortfolioNavigation from './pages/PortfolioNavigation';
import PatentDetail from './pages/PatentDetail';
import Pipeline from './pages/Pipeline';
import config from './config';

function App() {
  return (
    <Router basename={config.basename}>
      <div className="App">
        <Navigation />
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/catalogue" element={<Catalogue />} />
            <Route path="/search" element={<Search />} />
            <Route path="/navigation" element={<PortfolioNavigation />} />
            <Route path="/pipeline" element={<Pipeline />} />
            <Route path="/patent/:patentId" element={<PatentDetail />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
